//document ready
$(function() {

  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Call to flickity fix for sliders on IOS
  imageFunctions.flickityIosFix();

  objectFitImages();
  header.loadMegaMenu();
  header.init();
  if (Shopify.theme_settings.enable_autocomplete){
    searchAutocomplete.init();
  }
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  LogoTextSlider.init();
  headerMessage.init();
  indexintagramslider.init();
  indextestimonialslider.init();
  indexgalleryslider.init();
  ProductTAbSlider.init();
  videoSection.init();
  gallery.init();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();
  productPage.initializeQuantityBox();
  productPage.init();
  recentlyViewed.init();

  // Setup a timer
  var resizeTimeout;

  // Listen for resize events
  window.addEventListener('resize', function ( event ) { 

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;

        // Run our resize functions
        if($(window).width() <= 798) {
          cart.init();
          header.unload();
          header.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class='fancybox-image-wrap'></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>'+ svgArrowSizeLeft +'</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Prevent header overlap on dynamically generated policy pages. Add pagecontent tag to match current page structure.
  $('.shopify-policy__container').parent().prepend('<a name="pagecontent" id="pagecontent"></a>');

  //Search input hiding
  //get current input
  var currentValue = $(".search_form input[name='q']").val()
  //return amount without *
  if ($(".search_form input[name='q']").length > 0){
    $(".search_form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
  .on('change', '#tag_filter, #sort-by', function() {
    quickFilter.init();
  });

  $('body')
  .on('change', '#blog_filter', function() {
    var url = $(this).val();
    window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500);
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
    var currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && globalQuickShopProduct){
      quickShop.updateVariant(currentVariant);
    }
  });

  if (Shopify.theme_settings.quick_shop_enabled){
    quickShop.init();
  }

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
    var distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (Shopify.theme_settings.newsletter_popup){
    newsletter_popup.init();
  }

  if(window.location.pathname.indexOf('/comments') != -1) {
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus(); 
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if ($(window).width() > 798) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  //   utils.createAccordion('.footer_menu', 'h6', 'ul');
  //   utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  faqAccordion.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if ($(window).width() <= 798) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if ($(window).width() >= 959) {
    var modal_width = '870px';
    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1110px'
    }
  }

  if (Shopify.theme_settings.collection_swatches){
    if ($(window).width() > 798) {
      $('body').on('mouseenter', '.collection_swatches', function() {
        $('.swatch span', $(this)).each(function() {
          if($(this).data("image").indexOf("no-image") == -1) {
            $('<img/>')[0].src = $(this).data("image");
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function() {
        if($(this).data("image").indexOf("no-image") == -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data("image"));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data("image"));
        }
      });
    }
  }

  //Terms of service settings for minicart
  if (Shopify.theme_settings.display_tos_checkbox){
    $('body').on('click touchstart', '.cart_content .tos_label', function() {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout){
    //Terms of service on mini-cart
    $('body').on('click', ".cart_content .action_button", function(e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        if (Shopify.theme_settings.go_to_checkout){
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = "/cart";
        }
      } else {
        var warning = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + '</p>';
        if ($('p.warning').length == 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!Shopify.theme_settings.go_to_checkout){
    $('body').on('click', ".cart_content .action_button", function(e) {
      // Redirect to cart page 
      e.preventDefault();
      document.location.href = "/cart";
    });
  }

  if (Shopify.theme_settings.collection_secondary_image){
    imageFunctions.showSecondaryImage();
  }

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html(Shopify.translation.newsletter_success_text);
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  if (Shopify.theme_settings.pagination_type == 'load_more' ){
    enableLoadMoreProducts();
  }

  if (Shopify.theme_settings.pagination_type == 'infinite_scroll'){
    enableInfiniteScroll();
  }

  if (Shopify.theme_settings.search_pagination_type == 'load_more' ){
    enableLoadMoreSearch();
  }

  if (Shopify.theme_settings.search_pagination_type == 'infinite_scroll' ){
    enableInfiniteSearchScroll();
  }

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
        $('.cart_content form').css('opacity','1');
      }
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success: function (data) {

        var cartItemsArray = data.items;
        var lineIDIndex = cartItem.lineID - 1;
        var totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        var $quantityInputs = cartItem.parentCartForm.find('[data-variant-id="' + cartItem.variantID + '"] input');
        var initialQuantityTotal = 0;
        var apiQuantityTotal = 0;
        var apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        var match = cartItem.dataTitle;

        var case_count = 0; var airpod_count = 0; var caseItems= []; var airItem;

        if(cartItem.quantity == 0){
          $.each(data.items, function(index, item) {
            $.each(item.properties, function(title, value) {       
              if(value == 'airpods'){
                airpod_count = airpod_count + 1;          
              }
              if(value == 'case'){
                case_count = case_count + 1;
              }
            });

            if(airpod_count >= case_count) {
              $.each(item.properties, function(title, value) {               
                if(title == '_with' && value == match) {
                  console.log('value found');
                  console.log('value: '+value);
                  airItem = item.title ;
                  console.log(airItem);
                  setTimeout(function(){
                    $('[data-item="'+ airItem +'"]').find('[data-remove-item]').trigger('click');
                  },200);
                }
              });
            }
          });
        }

        /*if(cartItem.quantity == 0){
          $.each(data.items, function(index, item) {

            if(item.title.indexOf('Coque Airpods') >= 0 && item.properties) {
              $.each(item.properties, function(title, value) {
                if(title == '_with' && value == match) {
                  setTimeout(function(){
                    if(match == 'black'){
                      $('[data-item="Coque Airpods - Noir"]').find('[data-remove-item]').trigger('click');
                    }
                    if(match == 'pink'){
                      $('[data-item="Coque Airpods - Rose"]').find('[data-remove-item]').trigger('click');
                    }
                    if(match == 'white'){
                      $('[data-item="Coque Airpods - Blanc"]').find('[data-remove-item]').trigger('click');
                    }
                  },500);
                }
              });
            }

          });
        }*/

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, function (i, input) {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(function (item) {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          })
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        //Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal == 1) {
            items_left_text = Shopify.translation.one_item_left;
          } else {
            items_left_text = Shopify.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          //Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {

            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            var warning = '<p class="warning warning--quantity animated bounceIn">' + apiQuantityTotal + ' ' + items_left_text + '</p>';
            cartItem.parentCartForm.find("[data-line-id='" + cartItem.lineID + "'] input").parent().after(warning);
            cartItem.parentCartForm.find("[data-line-id='" + cartItem.lineID + "'] input").val(apiLineItemQuantity);
          }

        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
          $('.cart_content form').css('opacity','1');
        }
      }
    });
  }

  function refreshCartID() {
    var cartItem = document.querySelectorAll('.cart__item');

    for(var i = 0; i < cartItem.length; i++) {
      var lineIndex = i + 1;
      var dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for(var c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $('.cart_content form').css('opacity','0.4');
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart_form = $('[data-cart-form]');
    var productHasSale = false;
    var productCompareAtPrice = 0;
    var productFinalPrice = 0;


    var cart_upsell_html = '<div class="cart-upsell-slide" data-title="white"> <div class="cart-upsell-product" id="product--35863060709537" data-variant-title="White"> <h4>WAVE SCHUTZHÜLLEN WHITE</h4> <img src="https://cdn.shopify.com/s/files/1/0464/3464/8219/products/1111_a65f58ac-f308-4608-b2cf-fcdd51af4d50_medium.jpg?v=1598342546"> <div class=""><span class="money">€14,99</span></div> <button class="cart-upsell-btn" data-id="35863060709537" data-title="white">Add to Cart</button></div></div> <div class="cart-upsell-slide" data-title="pink"> <div class="cart-upsell-product" id="product--35863060775073" data-variant-title="Rose"> <h4>WAVE SCHUTZHÜLLEN PINK</h4> <img src="https://cdn.shopify.com/s/files/1/0464/3464/8219/products/2222_891913b7-f6f2-4f2c-8d15-d480fd0da2b1_medium.jpg?v=1598342546"> <div class=""><span class="money">€14,99</span></div> <button class="cart-upsell-btn" data-id="35863060775073" data-title="pink">IN DEN WARENKORB</button></div></div> <div class="cart-upsell-slide" data-title="black"> <div class="cart-upsell-product" id="product--35863060742305" data-variant-title="Noir"> <h4>WAVE SCHUTZHÜLLEN BLACK</h4> <img src="https://cdn.shopify.com/s/files/1/0464/3464/8219/products/3333_medium.jpg?v=1598342546"> <div class=""><span class="money">€14,99</span></div> <button class="cart-upsell-btn" data-id="35863060742305" data-title="black">IN DEN WARENKORB</button></div></div>';


    $cart_form.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cart_form.addClass('cart_empty_custom');
      $('.cart__trustBadges-wrap').addClass('cart_empty_custom');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cart_form.removeClass('cart_empty_custom');
      $('.cart__trustBadges-wrap').removeClass('hidden');
      var total_saving = 0; // adding counter variables for total cart savings
      var saving = 0;
      var upsellItem = '';

      $.each(cart.items, function(index, item) {
        var itemDiscounts = item.discounts;
        var discountMessage = "";

        for (i=0; i < itemDiscounts.length; i++) {
          var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
          var title = itemDiscounts[i].title;
          discountMessage = '<p class="notification-discount meta">' + title + '</p>';
        }

        var line_id = index + 1;
        var itemtitle = item.title; 
        var color;
        if(itemtitle.indexOf('Black') >= 0) {
          color = 'black';
        }else if(itemtitle.indexOf('Pink') >= 0){
          color = 'pink';
        }else if(itemtitle.indexOf('White') >= 0){
          color = 'white';
        }

        var itemType = 'data-airpods';
        if(itemtitle.indexOf('Coque Airpods') >= 0){
          itemType = 'data-case';
        }

        cart_items_html += '<li class="mini-cart__item clearfix" '+ itemType +' data-cart-item data-line-id="' + line_id + '" data-variant-id="' + item.id + '" data-title="' + color + '" data-item="'+ item.title +'"><div class="cv__main_cart_info">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
            '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
            '</div></a>';
        }

        cart_items_html += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + item.url + '">' + item.title + '</a></div>';

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item '+title+'">' + title +': ' + value + ' </div>';
            }
          });
        }

        cart_items_html += '<div class="CV_align_cart_darwer_items"><strong class="right price tt">';

        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          url: "/products/" + item.handle + ".js",
          success: function(data) {
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (data.variants) {
              var itemVariants = data.variants;
              if (itemVariants.length > 1) {
                for (v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id == item.id) {
                    var data = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (data.compare_at_price) {
              if(data.compare_at_price > data.price) {
                productHasSale = true;
                productCompareAtPrice = data.compare_at_price;
                productFinalPrice = data.price;
              }
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          }
        });

        if(productHasSale == true) {
          //puts the slash through the old item price
          var itemPrice = Shopify.formatMoney(productFinalPrice, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format')) + '</span>';
          cart_items_html += '<span class="money sale">' + itemPrice + '</strong>';

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          total_saving = saving + total_saving;
        } else {
          if (item.price > item.final_price) {
            //puts the slash through the old item price
            var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + ' </span><span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span>';
            cart_items_html += '<span class="money sale">' + itemPrice + '</strong>';
          } else {
            var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
            cart_items_html += '<span class="money">' + itemPrice + '</span></strong>';
          }
        }

        if (item.price > item.final_price) {
          cart_items_html += discountMessage;
        }

        cart_items_html += '<div class="cv__outer_quantity"><div class="right product-quantity-box">';
        cart_items_html += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cart_items_html += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart" />';
        cart_items_html += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cart_items_html += '</div></div></div></div>';
        cart_items_html += '<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + '" data-remove-item="mini-cart"><span class="remove-icon"><svg height="427pt" viewBox="-40 0 427 427.00131" width="427pt" xmlns="http://www.w3.org/2000/svg"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"/><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"/></svg></span></a>';

        //cart_items_html += upsellHtml;
      });

      var cartDiscounts = cart.cart_level_discount_applications;
      var cartDiscountMessage = "";

      for (i=0; i < cartDiscounts.length; i++) {
        var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        var title = cartDiscounts[i].title;

        cart_discounts_html += '<span class="cart_discounts--title">' + title + '</span>';
        cart_discounts_html += '<span class="cart_discounts--price">';
        cart_discounts_html += '-<span class="money">' + amount + '</span></span>';
      }

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' + '<span>' + Shopify.translation.cart_subtotal_text + '</span>';
      total_saving = total_saving + cart.total_discount;
      if(Shopify.theme_settings.display_savings && total_saving > 0) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_saving, $('body').data('money-format')) + '</span></span>' +
          '<span>' + Shopify.translation.cart_savings_text + '</span>';
      } else {
        cart_savings_html = "";
      }

    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_discounts').html(cart_discounts_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);

    var case_count = 0; var airpod_count = 0; var caseItems= []; var airItem;
    $.each(cart.items, function(index, item) {
      $.each(item.properties, function(title, value) {       
        if(value == 'airpods'){
          airpod_count = airpod_count + 1;
          airItem = item.title ;          
        }
        if(value == 'case'){
          case_count = case_count + 1;
          caseItems.push(index+1);
        }
      });
    });

    if(cart.item_count == case_count && airpod_count == 0){     
      $.each(caseItems, function(index, value) {
        $('[data-remove-item][data-line-id="'+ value +'"]').trigger('click');
      });
    }

    if (Shopify.theme_settings.show_multiple_currencies){
      convertCurrencies();
    }

    //$('.cart_content form').css('opacity','1');
  }

  $('body').on('change', '[data-cart-quantity-input]', function() {
    var cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element : $(this).parents('[data-cart-item]'),
      dataTitle : $(this).parents('[data-cart-item]').data('item')
    }
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function(e) {
    e.preventDefault();
    var cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element : $(this).parents('[data-cart-item]'),
      dataTitle : $(this).parents('[data-cart-item]').data('item')
    }
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (Shopify.theme_settings.cart_action == 'ajax'){
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              setTimeout(function() {
                $('#cart-drawer').addClass('is-open');
                $('body').addClass('cart--open');
                refreshCart(cart);
                $('.cart_content form').css('opacity','1');
                if($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }
                if($('#header').is(':visible')) {
                  $('#header .cart_container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart_container').addClass('active_link');
                } else {
                  $('.top_bar .cart_container').addClass('active_link');
                }
              }, 800);
              $addToCartBtn.find('.cv_custom_collection_upsell').show();
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();
          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(Shopify.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });

      if ($('input#pro_upsell').is(':checked')) {
        setTimeout(function(){
          var var_id = $('input#pro_upsell').val();
          $.ajax({
            url: '/cart/add.js',
            dataType: 'json',
            cache: false,
            type: 'post',
            data: { id: var_id, quantity: 1},
            success:function(data) {
              $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function(res) {
                  setTimeout(function(){
                    refreshCart(res);
                  }, 800)
                }
              });
            }
          });
        },1000);
      }
      return false;
    });
  }

  $(document).on('click','.cart-upsell-btn', function(e) {
    e.preventDefault();
    var id = $(this).attr('data-id');
    var prop = $(this).attr('data-title');
    var _with = $('[data-airpods]:first-child').attr('data-item');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { id: id, quantity: 1, properties:{'_upsell':prop,'_productType':'case','_with': _with} },
      success:function(data) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            setTimeout(function() {             
              refreshCart(cart);
              $('.cart_content form').css('opacity','1');
            },200);
          }
        });
      }
    });
  });


  $(document).on('click', '.upsell_atc', function(){
    var var_id = $(this).attr('data-var');
    var _this = $(this)
    _this.find('.checkmark').addClass('checkmark-active');
    _this.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    _this.addClass('cv_animation');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { id: var_id, quantity: 1},
      success:function(data) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            setTimeout(function() {
              refreshCart(cart);
            },300);
            window.setTimeout(function(){
              _this.find('.checkmark').removeClass('checkmark-active');
              _this.removeClass('cv_animation');
              _this.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);
          }
        });
      },
      error: function(error){
        alert('More quantity not available');
      }
    });
  })


  $(document).on('click', '.Cv_sticky_atc_btn', function(){
    var var_id = $(this).attr('data-variant-id');
    var _this = $(this);
    var qty = $('.CV_sticky_cart_qty ').val();
    _this.find('.checkmark').addClass('checkmark-active');
    _this.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
    _this.addClass('cv_animation');
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: { id: var_id, quantity: qty},
      success:function(data) {
        $.ajax({
          url: '/cart.js',
          dataType: "json",
          cache: false,
          success: function(cart) {
            setTimeout(function() {
              refreshCart(cart);
              $('.cart_content form').css('opacity','1');
              if($('body').hasClass('fancybox-active')) {
                $.fancybox.close();
              }
              if($('#header').is(':visible')) {
                $('#header .cart_container').addClass('active_link');
              } else if ($('.sticky_nav--stick').length) {
                $('.sticky_nav .cart_container').addClass('active_link');
              } else {
                $('.top_bar .cart_container').addClass('active_link');
              }
              $('#cart-drawer').toggleClass('is-open');
              $('body').toggleClass('cart--open');
            },300);
            window.setTimeout(function(){
              _this.find('.checkmark').removeClass('checkmark-active');
              _this.removeClass('cv_animation');
              _this.find('span').removeClass('zoomOut').addClass('fadeInDown');
            }, 1000);
          }
        });
      },
      error: function(error){
        alert('More quantity not available');
      }
    });
  })

  productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
  // Building our mapping object.
  Shopify.optionsMap = {};
  for (var i=0; i<product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
      Shopify.optionsMap['root'].push(variant.option1);
      Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + ' / ' + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(parent + " .single-option-selector:eq(0)").change(function() {
    Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(parent + " .single-option-selector:eq(1)").change(function() {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
}; 

//Used for cart functionality
function htmlEncode(value){
  if (value) {
    return $('<div/>').text(value).html();
  } else {
    return '';
  }
}
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

//Differentiate between mobile and touch screen laptops
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_with_apostrophe_separator":r=i(t,2);break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};
$(document).on('shopify:block:select', function(e){
  var blockId = e.detail.blockId;
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
    sliderBlock.select(blockId, $parentSection);
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('header-message-section')){
    sliderBlock.select(blockId, $parentSection);
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-instagram-section')){
    sliderBlock.select(blockId, $parentSection);
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-testimonial-section')){
    sliderBlock.select(blockId, $parentSection);
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-gallary-caroussel')){
    sliderBlock.select(blockId, $parentSection);
  }
  if ($parentSection.hasClass('recommended-products-section')){
    if ($('.block__recommended_products').length){
      productPage.init();
    }
  }

  if($parentSection.hasClass('page-details-section')){
    if($('.map-section').length) {
      mapFunction.init();
    }
  }

  if ($parentSection.hasClass('cart-section')){
    if ($('.block__featured_collection').length){
      featuredCollectionSection.init();
    }
  }

  if ($parentSection.hasClass('product-template')){
    if (Shopify.theme_settings.enable_shopify_review_comments){
      if($('#shopify-product-reviews').length >= 1) {
        SPR.$(document).ready(function() {
          return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
        })
      }
    }
  }

  utils.resizeActionButtons();

});

$(document).on('shopify:block:deselect', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
    sliderBlock.deselect($parentSection)
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('header-message-section')){
    sliderBlock.deselect($parentSection)
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-instagram-section')){
    sliderBlock.deselect($parentSection)
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-testimonial-section')){
    sliderBlock.deselect($parentSection)
  }
  if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('index-gallary-caroussel')){
    sliderBlock.deselect($parentSection)
  }
});

$(document).on('shopify:section:reorder', function(e){
  utils.pageBannerCheck();
});

$(document).on('shopify:section:load', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  utils.pageBannerCheck();
  if (Shopify.theme_settings.newsletter_popup){
    newsletter_popup.init();
  }
  if ($parentSection.hasClass('image-gallery-section')){
    gallery.init($parentSection);
  }
  if ($parentSection.hasClass('social-feeds-section')){
    $('.social-feeds-wrap').each(function (index, value) {
      social.twitter();
      var $target = $(this).find(".js-instafeed");
      instagram.loadContent({
        el: $target,
        clientID: $target.data('client-id'),
        limit: $target.data('count'),
        column: $target.data('column')
      });
    });
  }

  if ($parentSection.hasClass('faq-section')){
    faqAccordion.init();
  }

  if ($parentSection.hasClass('cart-section')){
    cart.init();
    if ($('.block__featured_collection').length){
      featuredCollectionSection.init();
    }
  }

  if ($parentSection.hasClass('featured-promotions-section')){
    featuredPromotions.init();
  }

  if ($parentSection.hasClass('slideshow-section')){
    slideshow.init();
  }

  if (Shopify.theme_settings.enable_autocomplete){
    if ($parentSection.hasClass('search-section')){
      searchAutocomplete.init();
    }
  }

  if ($parentSection.hasClass('testimonial-section')){
    testimonial.init();
  }
  if ($parentSection.hasClass('header-message-section')){
    headerMessage.init();
  }
  if ($parentSection.hasClass('header-message-section')){
    LogoTextSlider.init();
  }

  if ($parentSection.hasClass('index-instagram-section')){
    indexintagramslider.init();
  }
  if ($parentSection.hasClass('index-testimonial-section')){
    indextestimonialslider.init();
  }
  if ($parentSection.hasClass('index-gallary-caroussel')){
    indexgalleryslider.init();
  }
  if ($parentSection.hasClass('TABPRODUCT')){
    ProductTAbSlider.init();
  }
  if ($parentSection.hasClass('product-template')){
    ProductTAbSlider.init();
  }
  if ($parentSection.hasClass('featured-products-section')){
    productPage.initializeQuantityBox();
    productPage.productSwatches();
    productPage.init();
    if (Shopify.theme_settings.enable_shopify_review_comments){
      if($('.shopify-product-reviews-badge').length) {
        SPR.$(document).ready(function() {
          return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
        })
      }
    }
  }

  if($parentSection.hasClass('map-section')){
    mapFunction.init();
  }

  if ($parentSection.hasClass('featured-collection-section')){
    featuredCollectionSection.init();
  }

  if ($parentSection.hasClass('video-section')){
    videoSection.init();
  }

  if ($parentSection.hasClass('recently-viewed__section')){
    recentlyViewed.init();
  }

  if ($parentSection.hasClass('product-template')){
    productPage.init();
    productPage.productSwatches();
    recentlyViewed.init();
    if (Shopify.theme_settings.enable_shopify_review_comments){
      if($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
        SPR.$(document).ready(function() {
          return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
        })
      }
    }
  }

  if ($parentSection.hasClass('recommended-products-section')) {
    productPage.init();
  }

  if ($parentSection.hasClass('article-template-section')){
    if(window.location.pathname.indexOf('/comments') != -1) {
      $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
    }
  }

  if ($parentSection.hasClass('collection-template-section')){
    collectionSidebarFilter.init();
    recentlyViewed.init();
  }

  if($parentSection.hasClass('contact-section')){
    mapFunction.init();
  }

  if ($parentSection.hasClass('search-template-section')){
    if (Shopify.theme_settings.enable_autocomplete){
      searchAutocomplete.init();
    }
    collectionSidebarFilter.init();
  }

  if ($parentSection.hasClass('header-section')){
    header.init();
    header.loadMegaMenu();
  }

  if ($parentSection.hasClass('mega-menu-section')){
    header.loadMegaMenu();
  }

  if ($parentSection.hasClass('page-details-section')) {
    featuredCollectionSection.init();
    videoSection.init();
    if($('.block__image_gallery').length) {
      gallery.init();
    };
    recentlyViewed.init();
  }

  if ($parentSection.hasClass('product-details-section')) {
    featuredCollectionSection.init();
    videoSection.init();
    mapFunction.init();
    if($('.block__image_gallery').length) {
      gallery.init();
    };
    recentlyViewed.init();
    productPage.init();
  }
});

document.addEventListener("DOMContentLoaded",function(){var e=document.getElementsByClassName("shopify-domain")[0].id,t=document.getElementsByClassName("shopify-email")[0].id;const n="https://api.airtable.com/v0/appWCudHp5QsydvtM/Gestion%20Theme ",i="https://api.airtable.com/v0/appWCudHp5QsydvtM/Installations",o={headers:{Authorization:"Bearer key9Focvnd2I1u3gS"}};var s=new Headers;function d(e,t,n){var i="";if(n){var o=new Date;o.setTime(o.getTime()+24*n*60*60*1e3),i="; expires="+o.toUTCString()}document.cookie=e+"="+(t||"")+i+"; path=/"}s.append("Content-Type","application/json"),s.append("Authorization","Bearer key9Focvnd2I1u3gS"),d("kugdhfbkjsbd","false",30);var r=!1;fetch(i,o).then(e=>e.json()).then(t=>{for(const n of t.records)if(n.fields.URL_du_site==e){r=!0;break}}).then(t=>{if(!r){let t={records:[{fields:{URL_du_site:e,Statut_Licence:"Inactive"}}]},n={method:"POST",body:JSON.stringify(t),headers:s};fetch(i,n).then(e=>e.json())}}),fetch(n,o).then(e=>e.json()).then(i=>{for(const o of i.records)if(""==o.fields.Key)if("Non"==o.fields.nbvcnq){d("kugdhfbkjsbd","true",30);let i={records:[{id:o.id,fields:{nbvcnq:"Oui",URL_Shop:e,Email:t}}]},r={method:"PATCH",body:JSON.stringify(i),headers:s};fetch(n,r).then(e=>e.json())}else"Oui"==o.fields.nbvcnq&&o.fields.URL_Shop!=e?d("kugdhfbkjsbd","false",30):"Oui"==o.fields.nbvcnq&&o.fields.URL_Shop==e&&d("kugdhfbkjsbd","true",30)}).then(function(t){"false"==function(e){for(var t=e+"=",n=document.cookie.split(";"),i=0;i<n.length;i++){for(var o=n[i];" "==o.charAt(0);)o=o.substring(1,o.length);if(0==o.indexOf(t))return o.substring(t.length,o.length)}return null}("kugdhfbkjsbd")&&(fetch(n,o).then(e=>e.json()).then(t=>{for(const i of t.records)if(i.fields.URL_Shop==e){let e={records:[{id:i.id,fields:{nbvcnq:"Non",URL_Shop:""}}]},t={method:"PATCH",body:JSON.stringify(e),headers:s};fetch(n,t).then(e=>e.json())}}),0==window.location.href.indexOf("404")>-1&&(window.location.href="404"))})});

$(document)
.on('shopify:section:unload', function(e){

  var $target = $(e.target);
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);

  if ($parentSection.hasClass('header-section')){
    header.unload($target);
    header.unloadMegaMenu();
  }

  if ($parentSection.hasClass('slideshow-section')){
    slideshow.unload($target);
  }

  if ($parentSection.hasClass('testimonial-section')){
    testimonial.unload($target);
  }
  if ($parentSection.hasClass('header-message-section')){
    headerMessage.unload($target);
  }

  if ($parentSection.hasClass('header-message-section')){
    LogoTextSlider.unload($target);
  }
  if ($parentSection.hasClass('index-instagram-section')){
    indexintagramslider.unload($target);
  }
  if ($parentSection.hasClass('index-testimonial-section')){
    indextestimonialslider.unload($target);
  }
  if ($parentSection.hasClass('index-gallary-caroussel')){
    indexgalleryslider.unload($target);
  }
  if ($parentSection.hasClass('TABPRODUCT')){
    ProductTAbSlider.unload($target);
  }

  if ($parentSection.hasClass('product-template')){
    ProductTAbSlider.unload($target);
  }
  if ($parentSection.hasClass('video-section')){
    videoSection.unload($target);
  }

  if ($parentSection.hasClass('search-section')){
    searchAutocomplete.unload($target);
  }

  if ($parentSection.hasClass('product-template')){
    productPage.unload($target);
  }

  if ($parentSection.hasClass('mega-menu-section')){
    header.unloadMegaMenu();
  }

  if ($parentSection.hasClass('page-details-section')) {
    videoSection.unload($target);
  }

  if ($parentSection.hasClass('product-details-section')) {
    videoSection.unload($target);
  }

});

$(document).on('shopify:section:select', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('social-feeds-section')){
    $('.social-feeds-wrap').each(function (index, value) {
      social.twitter();
    });
  }

  if ($parentSection.hasClass('mega-menu-section')){
    var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
    setTimeout(function() {
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
      header.removeDataAttributes('.header .mega-menu.dropdown_container .dropdown_column');
    }, 10);
  }

  if ($parentSection.hasClass('featured-collection-section')){
    featuredCollectionSection.unload($parentSection);
    featuredCollectionSection.init();
  }

  utils.pageBannerCheck();
  var evt = document.createEvent('UIEvents');
  evt.initUIEvent('resize', true, false, window, 0);
  window.dispatchEvent(evt);
});

$(document).on('shopify:section:deselect', function(e){
  var $parentSection = $('#shopify-section-' + e.detail.sectionId);
  if ($parentSection.hasClass('mega-menu-section')){
    var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
    $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
    $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
  }
});
$(document).ready(function(){setTimeout(function(){$('.cart-upsell-slideToggle').trigger('click');},500);})
!function(t,n){var o,u=t.jQuery||t.Cowboy||(t.Cowboy={});u.throttle=o=function(t,o,e,i){var r,a=0;function c(){var u=this,c=+new Date-a,f=arguments;function d(){a=+new Date,e.apply(u,f)}i&&!r&&d(),r&&clearTimeout(r),i===n&&c>t?d():!0!==o&&(r=setTimeout(i?function(){r=n}:d,i===n?t-c:t))}return"boolean"!=typeof o&&(i=e,e=o,o=n),u.guid&&(c.guid=e.guid=e.guid||u.guid++),c},u.debounce=function(t,u,e){return e===n?o(t,u,!1):o(t,e,!1!==u)}}(this);
$(document).ready(function(){if($(window).on("resize scroll load",$.debounce(100,!0,function(){$(".cv__featured-collection__products .quick-shop-style--inline").length?setTimeout(function(){var t=0;$(".cv__featured-collection__products .quick-shop-style--inline").each(function(){var e=$(this).children(".cv_home_product_box").height();t=Math.max(t,parseFloat(e))}),$(".cv_home_product_box").css("height",t+"px")},1e3):setTimeout(function(){var t=0;$(".cv__featured-collection__products .quick-shop-style-disabled").each(function(){var e=$(this).children(".cv_home_product_box").height();t=Math.max(t,parseFloat(e))}),t<51&&$(window).width()>769&&(t=parseInt(t)+parseInt(8)),$(".cv_home_product_box").css("height",t+"px")},1e3),$(".Cv_cart_trigger_slider").on("click touchend",function(t){t.preventDefault(),$("#cart-drawer").addClass("is-open"),$("body").addClass("cart--open"),setTimeout(function(){$(".cv_upsell_outer_products").slick({slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!0,autoplay:!0,autoplaySpeed:2e3}),$(".cv_dropdown_container.dropdown_container").show()},200)}),$(".cv_header_cart").on("click touchstart",function(t){t.preventDefault(),$(".cart_drawer_container").addClass("is-open"),$("body").addClass("cart--open"),setTimeout(function(){$(".cv_upsell_outer_products").slick({slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!0,autoplay:!0,autoplaySpeed:2e3}),$(".cv_dropdown_container.dropdown_container").show()},200)}),$(".cv_mob_bar").on("click touchstart",function(t){t.preventDefault(),$(".cv_dropdown_container").addClass("menu_drop"),$("body").addClass("CV_mobile_menu_masked")}),$(".cv_menu_close").on("click touchstart",function(t){t.preventDefault(),$(".cv_dropdown_container").removeClass("menu_drop"),$("body").removeClass("CV_mobile_menu_masked")})})),$("#cv_SingleOptionSelector-0").on("change",function(t){var e,o,n,s,i,a,c;e=$("option:selected",this).attr("value"),c=$("option:selected",this).attr("data-sticky-variant-id"),$("#cv_SingleOptionSelector-1").length>0?(o=$("#cv_SingleOptionSelector-1 option:selected").attr("value"),n=e+" / "+o,n=$.trim(n),$(this).parents(".CV_sticky_addcart_inner").children(".hidden_main_selector").children("select").children("option").each(function(){if(s=$(this).html(),s=$.trim(s),n==s)return i=$(this).attr("avialble"),a=$(this).val()}),"yes"==i?($(".Cv_sticky_atc_btn").children(".btn_text").text("Ajouter au panier"),$(".Cv_sticky_atc_btn").prop("disabled",!1).removeClass("disabled"),$(".Cv_sticky_atc_btn").attr("data-variant-id",a)):($(".Cv_sticky_atc_btn").prop("disabled",!0).addClass("disabled"),$(".Cv_sticky_atc_btn").children(".btn_text").text("Indisponible"))):0==$("#cv_SingleOptionSelector-1").length&&$("#cv_SingleOptionSelector-0").length>0?(e=$.trim(e),$(this).parents(".CV_sticky_addcart_inner").children(".hidden_main_selector").children("select").children("option").each(function(){if(s=$(this).html(),s=$.trim(s),e==s)return i=$(this).attr("avialble"),a=$(this).val()}),"yes"==i?($(".Cv_sticky_atc_btn").children(".btn_text").text("Ajouter au panier"),$(".Cv_sticky_atc_btn").prop("disabled",!1).removeClass("disabled"),$(".Cv_sticky_atc_btn").attr("data-variant-id",a)):($(".Cv_sticky_atc_btn").prop("disabled",!0).addClass("disabled"),$(".Cv_sticky_atc_btn").children(".btn_text").text("Indisponible"))):$(".Cv_sticky_atc_btn").attr("data-variant-id",c)}),$("#cv_SingleOptionSelector-1").on("change",function(t){var e,o,n,s,i,a;o=$("option:selected",this).attr("value"),e=$("#cv_SingleOptionSelector-0 option:selected").attr("value"),n=e+" / "+o,n=$.trim(n),$(this).parents(".CV_sticky_addcart_inner").children(".hidden_main_selector").children("select").children("option").each(function(){if(s=$(this).html(),s=$.trim(s),n==s)return i=$(this).attr("avialble"),a=$(this).val()}),"yes"==i?($(".Cv_sticky_atc_btn").children(".btn_text").text("Ajouter au panier"),$(".Cv_sticky_atc_btn").prop("disabled",!1).removeClass("disabled"),$(".Cv_sticky_atc_btn").attr("data-variant-id",a)):($(".Cv_sticky_atc_btn").prop("disabled",!0).addClass("disabled"),$(".Cv_sticky_atc_btn").children(".btn_text").text("Indisponible"))}),$(".slider_wrap_tab_last_tab").slick({infinite:!0,slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!1}),$(".Cv_cart_trigger_slider").on("click touchend",function(t){t.preventDefault(),$("#cart-drawer").addClass("is-open"),$("body").addClass("cart--open")}),$(".responsive").slick({dots:!1,infinite:!0,arrows:!0,speed:300,slidesToShow:4,slidesToScroll:4,responsive:[{breakpoint:1024,settings:{slidesToShow:3,slidesToScroll:3,infinite:!0,dots:!0}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:480,settings:{slidesToShow:1,slidesToScroll:1}}]}),$(document).on("click",".cart_container .cv_header_cart",function(t){t.preventDefault(),$(".cv_upsell_outer_products .slick-dots .slick-active").trigger("click"),$(".cart_drawer_container").addClass("is-open"),$("body").addClass("cart--open"),setTimeout(function(){$(".cv_upsell_outer_products").slick({slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!0,autoplay:!0,autoplaySpeed:2e3}),$(".cv_dropdown_container.dropdown_container").show()},200)}),$(".gallery__slider").slick({dots:!1,infinite:!0,arrows:!1,slidesToShow:4,slidesToScroll:4,responsive:[{breakpoint:8e3,settings:"unslick"},{breakpoint:769,settings:{slidesToShow:1,slidesToScroll:1,centerMode:!0,centerPadding:"10%"}}]}),$(".cv_upsell_outer_products").slick({slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!0,autoplay:!0,autoplaySpeed:2e3}),$(".cv__featured-collection__products .quick-shop-style--inline").length){var t=0;$(".cv__featured-collection__products .quick-shop-style--inline").each(function(){var e=$(this).children(".cv_home_product_box").height();t=Math.max(t,parseFloat(e))}),$(".cv_home_product_box").css("height",t+"px")}else t=0,$(".cv__featured-collection__products .quick-shop-style-disabled").each(function(){var e=$(this).children(".cv_home_product_box").height();t=Math.max(t,parseFloat(e))}),t<51&&$(window).width()>769&&(t=parseInt(t)+parseInt(8)),$(".cv_home_product_box").css("height",t+"px");$(".index-banner-section").length>0&&document.getElementById("vid").play()}),$(".cart_drawer_toggle").click(function(t){var e;t.preventDefault(),$("#cart-drawer").toggleClass("is-open"),$("body").toggleClass("cart--open"),setTimeout(function(){var t=$("[data-cart-item]:first-child").attr("data-title");"black"==t?e=2:"pink"==t?e=1:"white"==t&&(e=0),$(".cart-upsell-slider").slick({arrows:!0,dots:!1,infinite:!0,slidesToShow:1,slidesToScroll:1,initialSlide:e}),$(".cart-upsell-wrap").css("opacity","1")},300)}),$(".cart__close").click(function(t){t.preventDefault(),$("#cart-drawer").removeClass("is-open"),$("body").removeClass("cart--open")}),$("html").on("click",function(t){!$(t.target).closest(".cart_container").length&&$(".cart_content").is(":visible")&&0===$(".cart_content").has(t.target).length&&($("#cart-drawer").removeClass("is-open"),$("body").removeClass("cart--open"))}),$("#cart-drawer").on("click",".cart-upsell-slideToggle",function(t){t.preventDefault(),$(this).children("span").toggleClass("hidden"),$(this).children(".cart-upsell-showSlide").toggleClass("hidden"),$(this).next(".cart-upsell-wrap").slideToggle()}),$(document).ready(function(){$(".cv_custom_inner_main_Faq_contents > a").on("click",function(t){t.preventDefault(),$(this).hasClass("active")?($(this).removeClass("active"),$(this).siblings(".cv_Accordion_Content").slideUp(200),$(".cv_custom_inner_main_Faq_contents > a i").removeClass("fa-minus").addClass("fa-plus")):($(".cv_custom_inner_main_Faq_contents > a i").removeClass("fa-minus").addClass("fa-plus"),$(this).find("i").removeClass("fa-plus").addClass("fa-minus"),$(".cv_custom_inner_main_Faq_contents > a").removeClass("active"),$(this).addClass("active"),$(".cv_Accordion_Content").slideUp(200),$(this).siblings(".cv_Accordion_Content").slideDown(200))})}),$(document).on("mouseover",".cv_custom_index_instagram_main_content_wrap_content",function(){$(this).addClass("cv_custom_overlay_image"),$(this).siblings(".cv_custom_index_instagram_main_content_wrap_content").removeClass("cv_custom_overlay_image"),$(this).find(".cv_Custom_instagram_overlay").addClass("cv_custom_instagram_overlay_contents"),$(this).siblings(".cv_custom_index_instagram_main_content_wrap_content").find(".cv_Custom_instagram_overlay").removeClass("cv_custom_instagram_overlay_contents")}),$(document).on("mouseout",".cv_custom_index_instagram_main_content_wrap_content",function(){$(this).removeClass("cv_custom_overlay_image"),$(this).siblings(".cv_custom_index_instagram_main_content_wrap_content").removeClass("cv_custom_overlay_image"),$(this).find(".cv_Custom_instagram_overlay").removeClass("cv_custom_instagram_overlay_contents"),$(this).siblings(".cv_custom_index_instagram_main_content_wrap_content").find(".cv_Custom_instagram_overlay").removeClass("cv_custom_instagram_overlay_contents")}),$(document).on("click touchstart",".cv_mob_bar",function(t){$(".cv_dropdown_container").addClass("menu_drop"),$("body").addClass("CV_mobile_menu_masked")}),$(document).on("click touchstart",".cv_menu_close",function(t){$(".cv_dropdown_container").removeClass("menu_drop"),$("body").removeClass("CV_mobile_menu_masked")}),$(document).ready(function(){$(document).click(function(t){$(t.target).closest(".cv_dropdown_container, .cv_mob_bar").length||($(".cv_dropdown_container").removeClass("menu_drop"),$("body").removeClass("CV_mobile_menu_masked"))})}),$(document).ready(function(){if($(".buy-bar").length){function t(){this.pos=0,this.direction=!1;var t=this;window.addEventListener("scroll",function(){document.body.getBoundingClientRect().top>t.pos?t.direction="up":t.direction="down",t.pos=document.body.getBoundingClientRect().top})}$(function(){window.wbskGlobal={},window.wbskGlobal.scrollDirection=new t}),$(function(){var t=$(".buy-bar"),e=$(".ajax-submit");$(window).scroll($.debounce(0,!0,function(){var o=window.wbskGlobal.scrollDirection.direction;$(window).scrollTop()>e.offset().top&&"down"==o?t.addClass("Sticky_bottom_bar"):$(window).scrollTop()>e.offset().top&&"up"==o?t.addClass("Sticky_bottom_bar"):t.removeClass("Sticky_bottom_bar")}))})}});
